module.exports = __webpack_public_path__ + "static/media/header-triangles.3b655ed2.svg";